/* eslint-disable */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface deleteFirmwareState {
  isLoading: boolean
  loadingError: string | null
  deleteFirmware: any
}

// Initial state of the slice
const initialState: deleteFirmwareState = {
  isLoading: true,
  loadingError: null,
  deleteFirmware: null
}

// Slice to return from action
export const deleteFirmwareSlice = createSlice({
  name: 'deleteFirmware',
  initialState,
  reducers: {
    resetDeleteFirmware: () => {
      return {
        isLoading: false,
        loadingError: null,
        deleteFirmware: null
      }
    },
    deleteFirmwareLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: null,
        deleteFirmware: null
      }
    },
    deleteFirmwareUpdateAction: (state, action: PayloadAction< any >) => {
      return {
        isLoading: false,
        loadingError: null,
        deleteFirmware: action.payload
      }
    },
    deleteFirmwareErrorAction: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        deleteFirmware: null
      }
    }
  }
})

// Actions to export
export const {
  deleteFirmwareLoadingAction,
  deleteFirmwareUpdateAction,
  deleteFirmwareErrorAction,
  resetDeleteFirmware
} = deleteFirmwareSlice.actions

export default deleteFirmwareSlice.reducer